import { SelectResponseSchema } from 'models/globalModels'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { getUrls, selectUrls } from 'services/api.enums'
import { getAPI } from 'services/CRUDServices'

export const useEmployeeAndZoneOptions = ({
  isOpen,
  onUpdate,
}: {
  isOpen: boolean

  onUpdate: () => void
}) => {

  const {CurrentHub}=useSelector((state:any)=>state.currentHubInfo)
  const [optionZone, setOptionZone] = useState<Array<any>>([])
  const [perssonelOption, setPersonnelOption] = useState([])

  const fetchZoneOptions = async () => {
    try {
      const res = await getAPI(selectUrls.countrytype)
      const filtered = res.data.payload.filter(
        (item: SelectResponseSchema) => item.id > 2
      )
      setOptionZone(filtered)
    } catch (error) {
      console.error('Failed to fetch zone options:', error)
    }
  }

  const fetchEmployeeOptions = async () => {
    try {
      const hubId = CurrentHub?.id

      if (!hubId) return

      const res = await getAPI(`${getUrls.employeefindbyhubid}/${hubId}`)
      setPersonnelOption(res.data.payload)
    } catch (error) {
      console.error('Failed to fetch employee options:', error)
    }
  }

  useEffect(() => {
    if (isOpen) {
      fetchEmployeeOptions()
      fetchZoneOptions()
    }
  }, [isOpen])

  return { optionZone, perssonelOption }
}
